<template>
  <div>
    <a-form :form="form" @submit="submitForm">
      <a-row class="contract-files" :gutter="20">
        <a-col :span="24">
          <a-row :gutter="20">
            <a-col :span="6">
              <div class="label mb-10">Contrato assinado</div>

              <div v-if="!doc">
                <a-upload
                  :multiple="false"
                  :action="`https://api.viajar.tur.br/v1/media/upload-to-s3?module=contracts&id=${tempContract.id}&sub-folder=signed-contract`"
                  :headers="{
                    authorization: `Bearer ${this.$store.state.token}`,
                  }"
                  @change="uploadedFile"
                  v-model="doc"
                  :disabled="!edit"
                >
                  <a-button type="dashed" size="large" :disabled="!edit">
                    <a-icon type="file-protect" />
                  </a-button>
                </a-upload>
              </div>

              <div v-if="doc" class="file-link relative">
                <a v-if="doc" :href="doc" target="_blank">
                  <img
                    v-if="checkFileType(doc)"
                    :src="doc"
                    style="max-width: 160px" alt="img"
                  />
                  <a-icon
                    v-else
                    class="cblue"
                    type="idcard"
                    style="font-size: 38px"
                  />
                </a>

                <a-icon
                  class="close-circle"
                  type="close-circle"
                  v-if="doc && edit"
                  @click="removefile('signed-contract')"
                />
              </div>
            </a-col>

            <a-col :span="6">
              <a-form-item>
                <div class="label">Data de criação</div>
                <a-date-picker
                  class="travel-input"
                  placeholder="Selecione"
                  format="DD/MM/YYYY HH:mm"
                  :showToday="false"
                  :allowClear="false"
                  :disabled="true"
                  v-mask="'##/##/####'"
                  v-decorator="[
                    'contract_files_signed_contract_created',
                    {
                      rules: [
                        {
                          required: false,
                          message: 'Obrigatório',
                        },
                      ],
                    },
                  ]"
                >
                  <a-icon slot="prefix" type="field-svg" />
                </a-date-picker>
              </a-form-item>
            </a-col>

            <a-col :span="6">
              <a-form-item>
                <div class="label">Data de validade</div>

                <a-date-picker
                  class="travel-input"
                  placeholder="Selecione"
                  format="DD/MM/YYYY"
                  :showToday="false"
                  :allowClear="true"
                  :disabled="!edit"
                  v-mask="'##/##/####'"
                  v-decorator="[
                    'contract_files_signed_contract_expires_at',
                    {
                      rules: [
                        {
                          required: false,
                          message: 'Obrigatório',
                        },
                      ],
                    },
                  ]"
                >
                  <a-icon slot="prefix" type="field-svg" />
                </a-date-picker>
              </a-form-item>
            </a-col>
          </a-row>
        </a-col>

        <a-col class="actions" :span="24">
          <a-button
            v-if="edit"
            @click="edit = false"
            class="ml-10 cancel"
            type="primary"
          >
            <a-icon type="close" />
          </a-button>

          <a-button
            v-if="!edit"
            @click="edit = true"
            class="ml-10 edit"
            type="primary"
          >
            <a-icon type="edit" />
          </a-button>

          <a-button
            v-if="edit"
            html-type="submit"
            class="ml-10 save"
            type="primary"
            style="padding: 0px 6px"
            :loading="loading"
          >
            <img
              v-show="!loading"
              src="@/assets/images/dashboard/sales/disket.png"
              alt="save"
            />
          </a-button>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
export default {
  props: {
    tempContract: Object,
    sale: Object,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      edit: false,
      loading: false,
      doc: "",
    };
  },
  mounted() {
    this.doc = this.tempContract["contract_files_signed_contract"];

    this.form.setFieldsValue({
      [`contract_files_signed_contract_created`]:
        this.tempContract["contract_files_signed_contract_created"],
      [`contract_files_signed_contract_expires_at`]:
        this.tempContract["contract_files_signed_contract_expires_at"],
    });
  },
  methods: {
    removefile(fileName) {
      if (fileName == "signed-contract") {
        this.doc = "";
        this.form.setFieldsValue({
          [`contract_files_signed_contract_created`]: "",
          [`contract_files_signed_contract_expires_at`]: "",
        });
      }
    },
    uploadedFile(response, e) {
      e;

      if (response.file.response != undefined) {
        if (response.file.response.url != undefined) {
          let urlPieces = response.file.response.url.split("/");

          if (urlPieces[5] == "signed-contract") {
            this.doc = response.file.response.url;
            this.tempContract["contract_files_signed_contract_created"] =
              response.file.response.created;
            setTimeout(() => {
              this.doc = response.file.response.url;
              this.form.setFieldsValue({
                [`contract_files_signed_contract_created`]:
                  response.file.response.created,
              });
            }, 100);
          }
        }
      }
    },
    checkFileType(fileUrl) {
      let flag = false;
      let filePieces = fileUrl.split(".");

      if (
        filePieces[filePieces.length - 1] == "jpg" ||
        filePieces[filePieces.length - 1] == "png"
      ) {
        flag = true;
      }

      return flag;
    },
    submitForm(e) {
      e.preventDefault();

      this.form.validateFields((err, values) => {
        values.id = this.tempContract.id;
        values.modified_by = {
          name: `${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name}`,
          id: this.$store.state.userData.id,
        };

        values.contract_files_signed_contract = this.doc;

        if (!err) {
          this.loading = true;
          this.$http
            .post("/contract/update-multi-meta", values)
            .then(({ data }) => {
              this.$message.success(data.message);

              this.edit = false;
              this.loading = false;

              this.$http
                .post("/log/create", {
                  user_id: this.$store.state.userData.id,
                  module_id: this.tempContract.id,
                  module: "contract",
                  action: "upload-id-card",
                  description: `${this.$store.state.userData.first_name} ${this.$store.state.userData.last_name} realizou o upload do contrato assinado no contrato #${this.tempContract.id}.`,
                })
                .then(({ data }) => {
                  data;
                });

              this.$emit("reloadSale");
            })
            .catch(({ response }) => {
              this.$message.error(response.data.message);
              this.loading = false;
            });
        } else {
          this.$message.error("Prrencha todos os campos.");
        }
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.contract-files
  .file-link
    display: inline-block
    .close-circle
      font-size: 19px
      color: red
      position: absolute
      right: -11px
      top: 0px
      border-radius: 10px
      background: #FFF
      cursor: pointer
  .label
    z-index: 4
    font-size: 10px
    font-weight: 500
    color: #aaa
    transition: .3s
    line-height: 1
    overflow: hidden
    text-overflow: ellipsis
    width: 100%
    white-space: nowrap
  .actions
    text-align: right
    border-top: 1px solid #eee
    padding: 10px 0 0 0
    margin-top: 20px
    .edit
      background: #f27935
      border-color: #f27935
      padding: 5px 10px
    .cancel
      background: #59595b
      border-color: #59595b
      padding: 5px 10px
    .update
      background: #2ecc71
      border-color: #2ecc71
      padding: 5px 10px
      width: 32px
    .save
      background: #00acec
      border-color: #00acec
      padding: 0 6px
      width: 32px
      text-align: center
</style>
